import { DateTime, dateTime } from 'aos-helpers/src/helpers/Time'
import {
    assigneesLabel,
    TaskCommonProps,
} from 'aos-services/src/services/tasks/types/task/BaseTask'
import { Box, colors, HStack, Icon, Text } from 'aos-ui-universal'
import { baseIcons } from 'aos-ui-universal/src/icons/compiled'
import { TFunction } from 'i18next'
import moment from 'moment'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { TaskIcon } from './icons'

export interface TaskBarContentProps {
    item: TaskCommonProps
    inTooltip?: boolean
    shorten?: boolean
}

export const TaskBarContent: FC<TaskBarContentProps> = ({ item, shorten = false }) => {
    const { t: translate } = useTranslation()

    return (
        <Box className='min-h-10 w-full overflow-hidden bg-background-elevation px-2 py-0.5'>
            <HStack className='items-center'>
                <HStack className='flex-1 items-center'>
                    <TaskIcon color={colors.content.default} category={item.category} />
                    <Text
                        size='P2'
                        weight='semiBold'
                        className='min-w-0 shrink whitespace-pre-line py-2 pl-2'
                    >
                        {item.title}
                    </Text>
                </HStack>
                {!shorten && item.assignees.length > 0 && (
                    <HStack className='ml-2 items-center'>
                        <Icon as={baseIcons.Users} size={16} className='text-content-default' />
                        <Text size='P2' weight='semiBold' className='shrink-0 pl-1'>
                            {assigneesLabel(item.assignees)}
                        </Text>
                    </HStack>
                )}
            </HStack>
            <HStack className='items-center'>
                {item.lastComment && (
                    <Text size='P2' className='min-w-0 flex-1 whitespace-pre-line py-2 pl-2'>
                        {`"${item.lastComment}"`}
                    </Text>
                )}
                {item.overdue && (
                    <Text size='P3' className='py-2 pl-2'>
                        {formatOverdue(translate, item.realEndTime)}
                    </Text>
                )}
            </HStack>
        </Box>
    )
}

const formatOverdue = (translate: TFunction, endTime?: DateTime) => {
    return `${translate('task-filter.overdue', { ns: 'tasks' })}: ${moment
        .duration(dateTime().diff(endTime))
        .format('h [hrs], m [min]')}`
}
